import { GET_SEARCH_UF } from 'govbr.frontend.policy/constants/ActionTypes';

export function getNoticiasUf({ uf_noticia, local_context = true, page = 1 }) {
  return {
    type: GET_SEARCH_UF,
    request: {
      op: 'get',
      path: '/@search-uf-noticia',
      params: {
        local_context,
        uf_noticia,
        page,
      },
    },
  };
}
